import {ChangeDetectorRef, Component, Inject, Input, OnChanges} from '@angular/core';
import {ThemeService} from "../../_services/theme.service";
import {take} from "rxjs";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CommentsComponent} from "../comments/comments.component";
import {ContentService} from "../../_services/content.service";
import {Community} from "../../_types/communities";
import {Router} from "@angular/router";

@Component({
    selector: 'app-recent-activity',
    templateUrl: './recent-activity.component.html',
    styleUrl: './recent-activity.component.scss'
})
export class RecentActivityComponent implements OnChanges {
    recentActivity: any[] = []
    loading: boolean | null = null;
    @Input() community: Community | null = null
    isDialog: boolean = false;

    constructor(protected themeService: ThemeService,
                public changeDetection: ChangeDetectorRef,
                private contentService: ContentService,
                public dialog: MatDialog,
                private router: Router,
                @Inject(MAT_DIALOG_DATA) public data: { community: Community }) {
        if (data.community) {
            this.community = data.community;
            this.isDialog = true;
            this.loadRecentActivity(this.community?.id);
        } else if (this.community) {
            this.loadRecentActivity(this.community?.id);
        }
    }

    ngOnChanges(): void {
        if (this.community) {
            this.loadRecentActivity(this.community?.id);
        }
    }

    loadRecentActivity(id: number | null): void {
        this.recentActivity = [];
        if (!id) return;
        setTimeout((): void => {
            // Delay loading wheel for 3 seconds.
            if (this.loading != false) {
                this.loading = true;
            }
        }, 2000);
        this.contentService.getRecentActivity(id, 15).subscribe({
            next: (result: any): void => {
                this.recentActivity = result.data.items;
                this.loading = false;
            },
            error: (): boolean => this.loading = false
        });
    }

    link(content: any): void {
        if (content.type.toLowerCase().includes('comment')) {
            this.contentService.getPostById(content.related_objects?.post?.id).pipe(take(1))
                .subscribe(post => {
                    this.router.navigate([], {
                        queryParams: {comment: content.related_objects?.comment?.id},
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                    });
                    this.contentService.getPostComments(post.id).pipe(take(1)).subscribe((comments) => {
                        this.changeDetection.detach();
                        const dialogRef: MatDialogRef<CommentsComponent> = this.dialog.open(CommentsComponent, {
                            data: {
                                comments: comments,
                                post,
                                commentForScroll: content.related_objects?.comment?.id
                            },
                            autoFocus: false,
                            panelClass: ['largeWindow', 'w-100', 'comments-modal'],
                        });
                        dialogRef.afterClosed().subscribe((): void => {
                            this.changeDetection.reattach();
                        });
                    });
                });
        } else {
            this.contentService.getPostById(content.related_objects?.post?.id).pipe(take(1))
                .subscribe(post => {
                    this.contentService.getPostComments(post.id).pipe(take(1)).subscribe((comments): void => {
                        this.changeDetection.detach();
                        const dialogRef: MatDialogRef<CommentsComponent> = this.dialog.open(CommentsComponent, {
                            data: {
                                comments: comments,
                                post,
                            },
                            autoFocus: false,
                            panelClass: ['largeWindow', 'w-100', 'comments-modal'],
                        });
                        dialogRef.afterClosed().subscribe((): void => {
                            this.changeDetection.reattach();
                        });
                    });
                });
        }

    }
}
